import { render } from "./UserStatisticsModal.vue?vue&type=template&id=7f7e62fd&scoped=true"
import script from "./UserStatisticsModal.vue?vue&type=script&lang=js"
export * from "./UserStatisticsModal.vue?vue&type=script&lang=js"

import "./UserStatisticsModal.vue?vue&type=style&index=0&id=7f7e62fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7e62fd"]])

export default __exports__